// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Partners Logo Bar - Continuous Moving Design */
.partners-logo-bar {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 60px 0;
  overflow: hidden;
  position: relative;
}

.partners-logo-bar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(45deg, transparent 48%, rgba(255, 255, 255, 0.1) 49%, rgba(255, 255, 255, 0.1) 51%, transparent 52%),
    linear-gradient(-45deg, transparent 48%, rgba(255, 255, 255, 0.1) 49%, rgba(255, 255, 255, 0.1) 51%, transparent 52%);
  background-size: 30px 30px;
  opacity: 0.3;
}

.partners-container {
  position: relative;
  z-index: 2;
}

.partners-header {
  text-align: center;
  margin-bottom: 40px;
}

.partners-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.partners-divider {
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, #3b82f6, #10b981);
  margin: 0 auto;
  border-radius: 2px;
}

/* Logo Scroll Container */
.logo-scroll-container {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.logo-scroll-track {
  display: flex;
  animation: scroll 30s linear infinite;
  gap: 40px;
  align-items: center;
  width: max-content;
}

.logo-scroll-track:hover {
  animation-play-state: paused;
}

.logo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  padding: 0 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.logo-item img {
  max-height: 100%;
  max-width: 120px;
  object-fit: contain;
  filter: grayscale(100%) opacity(0.6);
  transition: all 0.3s ease;
}

.logo-item-dafo img {
  max-width: 190px;
}

.logo-item:hover img {
  filter: grayscale(0%) opacity(1);
  transform: scale(1.1);
}

/* Scroll Animation */
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .partners-logo-bar {
    padding: 50px 0;
  }
  
  .partners-header {
    margin-bottom: 30px;
  }
  
  .partners-title {
    font-size: 1.25rem;
  }
  
  .logo-scroll-track {
    gap: 30px;
  }
  
  .logo-item {
    height: 70px;
    padding: 0 15px;
  }
  
  .logo-item img {
    max-width: 100px;
  }

  .logo-item-dafo img {
    max-width: 160px;
  }
}

@media (max-width: 768px) {
  .partners-logo-bar {
    padding: 40px 0;
  }
  
  .partners-header {
    margin-bottom: 25px;
  }
  
  .partners-title {
    font-size: 1.1rem;
  }
  
  .logo-scroll-track {
    gap: 24px;
    animation-duration: 25s;
  }
  
  .logo-item {
    height: 60px;
    padding: 0 12px;
  }
  
  .logo-item img {
    max-width: 80px;
  }

  .logo-item-dafo img {
    max-width: 130px;
  }
}

@media (max-width: 480px) {
  .partners-logo-bar {
    padding: 30px 0;
  }
  
  .partners-header {
    margin-bottom: 20px;
  }
  
  .partners-title {
    font-size: 1rem;
  }
  
  .partners-divider {
    width: 40px;
    height: 2px;
  }
  
  .logo-scroll-track {
    gap: 20px;
    animation-duration: 20s;
  }
  
  .logo-item {
    height: 50px;
    padding: 0 10px;
  }
  
  .logo-item img {
    max-width: 70px;
  }

  .logo-item-dafo img {
    max-width: 110px;
  }
}

/* Pause animation on reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .logo-scroll-track {
    animation: none;
  }
  
  .logo-scroll-container {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .logo-scroll-container::-webkit-scrollbar {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PartnersLogoBar/PartnersLogoBar.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;yHAEuH;EACvH,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qDAAqD;EACrD,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Partners Logo Bar - Continuous Moving Design */\n.partners-logo-bar {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  padding: 60px 0;\n  overflow: hidden;\n  position: relative;\n}\n\n.partners-logo-bar::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    linear-gradient(45deg, transparent 48%, rgba(255, 255, 255, 0.1) 49%, rgba(255, 255, 255, 0.1) 51%, transparent 52%),\n    linear-gradient(-45deg, transparent 48%, rgba(255, 255, 255, 0.1) 49%, rgba(255, 255, 255, 0.1) 51%, transparent 52%);\n  background-size: 30px 30px;\n  opacity: 0.3;\n}\n\n.partners-container {\n  position: relative;\n  z-index: 2;\n}\n\n.partners-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.partners-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 16px 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.partners-divider {\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(135deg, #3b82f6, #10b981);\n  margin: 0 auto;\n  border-radius: 2px;\n}\n\n/* Logo Scroll Container */\n.logo-scroll-container {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.logo-scroll-track {\n  display: flex;\n  animation: scroll 30s linear infinite;\n  gap: 40px;\n  align-items: center;\n  width: max-content;\n}\n\n.logo-scroll-track:hover {\n  animation-play-state: paused;\n}\n\n.logo-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 80px;\n  padding: 0 20px;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.logo-item img {\n  max-height: 100%;\n  max-width: 120px;\n  object-fit: contain;\n  filter: grayscale(100%) opacity(0.6);\n  transition: all 0.3s ease;\n}\n\n.logo-item-dafo img {\n  max-width: 190px;\n}\n\n.logo-item:hover img {\n  filter: grayscale(0%) opacity(1);\n  transform: scale(1.1);\n}\n\n/* Scroll Animation */\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .partners-logo-bar {\n    padding: 50px 0;\n  }\n  \n  .partners-header {\n    margin-bottom: 30px;\n  }\n  \n  .partners-title {\n    font-size: 1.25rem;\n  }\n  \n  .logo-scroll-track {\n    gap: 30px;\n  }\n  \n  .logo-item {\n    height: 70px;\n    padding: 0 15px;\n  }\n  \n  .logo-item img {\n    max-width: 100px;\n  }\n\n  .logo-item-dafo img {\n    max-width: 160px;\n  }\n}\n\n@media (max-width: 768px) {\n  .partners-logo-bar {\n    padding: 40px 0;\n  }\n  \n  .partners-header {\n    margin-bottom: 25px;\n  }\n  \n  .partners-title {\n    font-size: 1.1rem;\n  }\n  \n  .logo-scroll-track {\n    gap: 24px;\n    animation-duration: 25s;\n  }\n  \n  .logo-item {\n    height: 60px;\n    padding: 0 12px;\n  }\n  \n  .logo-item img {\n    max-width: 80px;\n  }\n\n  .logo-item-dafo img {\n    max-width: 130px;\n  }\n}\n\n@media (max-width: 480px) {\n  .partners-logo-bar {\n    padding: 30px 0;\n  }\n  \n  .partners-header {\n    margin-bottom: 20px;\n  }\n  \n  .partners-title {\n    font-size: 1rem;\n  }\n  \n  .partners-divider {\n    width: 40px;\n    height: 2px;\n  }\n  \n  .logo-scroll-track {\n    gap: 20px;\n    animation-duration: 20s;\n  }\n  \n  .logo-item {\n    height: 50px;\n    padding: 0 10px;\n  }\n  \n  .logo-item img {\n    max-width: 70px;\n  }\n\n  .logo-item-dafo img {\n    max-width: 110px;\n  }\n}\n\n/* Pause animation on reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .logo-scroll-track {\n    animation: none;\n  }\n  \n  .logo-scroll-container {\n    overflow-x: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  \n  .logo-scroll-container::-webkit-scrollbar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
